// import React, { useRef, useState } from "react"
// import { Helmet } from 'react-helmet-async';
// import { Container } from "@mui/material";
// import ReactQuill from 'react-quill';
// import axios from "axios";
// import Swal from 'sweetalert2';
// import { useNavigate } from "react-router-dom";

// import { Url, awsFileUrl } from "../url/url";
// import 'react-quill/dist/quill.snow.css';
// import "../App.css"

// const ageGroupOptions = ['0-12 months', '1-2 years', '3+ years', '5+ years', '10+ years'];
// const sizeOptions = ['Small', 'Medium', 'Large', 'Giant'];
// const energyOptions = ['Low Energy', 'Medium Energy', 'High Energy'];

// const AddPetBreed = () => {
//     const navigate = useNavigate()

//     const [descriptionValue, setDescriptionValue] = useState('');
//     const [careValue, setCareValue] = useState('');
//     const [loading, setLoading] = useState(false)
//     const [formValue, setFormValue] = useState({});

//     const [ageGroupSelectedOptions, setAgeGroupSelectedOptions] = useState([]);
//     const [ageGroupError, setAgeGroupError] = useState(false);
//     const errorRef = useRef(null);

//     // Top 5 Traits — kept as a comma separated input, split into an array on submit
//     const [traitsInput, setTraitsInput] = useState('');

//     const [uploadLoading, setUploadLoading] = useState(false);
//     const [progressValue, setProgressValue] = useState(0);
//     const [uploadStatus, setUploadStatus] = useState(false);

//     const [multipleFileProgress, setMultipleFileProgress] = useState(0)
//     const [totalfiles, setTotalFiles] = useState(0)
//     const [totalUpload, setTotalUpload] = useState(0)
//     const [multipleFileStatus, setMultipleFileStatus] = useState(false)

//     const handleAgeGroupChange = (option) => {
//         setAgeGroupSelectedOptions((prev) =>
//             prev.includes(option)
//                 ? prev.filter((item) => item !== option)
//                 : [...prev, option]
//         );
//     };

//     const formHandle = (e) => {
//         const name = e.target.name
//         const value = e.target.value
//         setFormValue({ ...formValue, [name]: value })
//     }

//     // ---------------------------------------------
//     // Thumbnail upload — same presigned-URL → S3 PUT pattern as products
//     // ---------------------------------------------
//     const thumbnailHandle = async (e) => {
//         const file = e.target.files[0]
//         const name = e.target.name
//         setUploadLoading(true)
//         setUploadStatus(false)

//         try {
//             if (file) {
//                 const response = await axios.post(`${Url}/api/createPresignedUrl/products`, {
//                     fileName: file.name,
//                     fileType: file.type
//                 })

//                 if (response.status === 200) {
//                     const { preSignedUrl, key } = response?.data
//                     const responseFileSave = await axios.put(preSignedUrl, file, {
//                         onUploadProgress: (progressEvent) => {
//                             const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                             setProgressValue(progress)
//                         },
//                     })

//                     if (responseFileSave.status === 200) {
//                         const fileUrl = `${awsFileUrl}/${key}`
//                         setFormValue({ ...formValue, [name]: fileUrl })
//                         setUploadStatus(true)
//                         setUploadLoading(false)
//                         setProgressValue(0)
//                     } else {
//                         setUploadLoading(false)
//                         setProgressValue(0)
//                         setUploadStatus(false)
//                         Swal.fire("Thumbnail upload failed, please try again!");
//                     }
//                 } else {
//                     setUploadLoading(false)
//                 }
//             } else {
//                 setUploadLoading(false)
//             }
//         } catch (error) {
//             console.log(error);
//             setUploadLoading(false)
//             setUploadStatus(false)
//             Swal.fire("Thumbnail upload failed, please try again!");
//         }
//     }

//     // ---------------------------------------------
//     // Gallery images upload (optional) — same sequential presigned-URL pattern
//     // ---------------------------------------------
//     const fileHandle = async (e) => {
//         const files = e.target.files;
//         const name = e.target.name;
//         const uploadedFiles = [];
//         setTotalFiles(files?.length);
//         setTotalUpload(0);
//         setMultipleFileProgress(0);
//         setMultipleFileStatus(true);

//         try {
//             await Array.from(files).reduce(async (previousPromise, file, i) => {
//                 await previousPromise;
//                 if (file) {
//                     const response = await axios.post(`${Url}/api/createPresignedUrl/products`, {
//                         fileName: file.name,
//                         fileType: file.type
//                     });

//                     if (response.status === 200) {
//                         const { preSignedUrl, key } = response?.data;
//                         const responseFileSave = await axios.put(preSignedUrl, file, {
//                             onUploadProgress: (progressEvent) => {
//                                 const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                                 setMultipleFileProgress(progress);
//                             },
//                         });

//                         if (responseFileSave.status === 200) {
//                             const fileUrl = `${awsFileUrl}/${key}`;
//                             setTotalUpload(i + 1);
//                             uploadedFiles.push(fileUrl);
//                         } else {
//                             throw new Error('File upload failed');
//                         }
//                     }
//                 }
//             }, Promise.resolve());

//             setFormValue({ ...formValue, [name]: uploadedFiles });
//             setMultipleFileStatus(false);
//         } catch (error) {
//             console.log(error);
//             Swal.fire("Images upload failed, please try again!");
//         } finally {
//             setMultipleFileStatus(false);
//         }
//     };

//     const submit = async (e) => {
//         e.preventDefault();
//         setLoading(true);
//         setAgeGroupError(false);

//         // Validate type / size / energy level
//         if (!formValue.type) {
//             Swal.fire("Please select Pet Type (Dog/Cat)!");
//             setLoading(false);
//             return;
//         }
//         if (!formValue.size) {
//             Swal.fire("Please select Size!");
//             setLoading(false);
//             return;
//         }
//         if (!formValue.energyLevel) {
//             Swal.fire("Please select Energy Level!");
//             setLoading(false);
//             return;
//         }

//         // Validate stat fields
//         if (!formValue.height || !formValue.weight || !formValue.lifeExpectancy || !formValue.origin || !formValue.shedding) {
//             Swal.fire("Please fill all breed stat fields (Height, Weight, Life Expectancy, Origin, Shedding)!");
//             setLoading(false);
//             return;
//         }

//         // Validate description
//         if (!descriptionValue) {
//             Swal.fire("Description is required!");
//             setLoading(false);
//             return;
//         }

//         // Thumbnail
//         if (uploadLoading) {
//             Swal.fire("Thumbnail image abhi upload ho raha hai, thoda ruk jao!");
//             setLoading(false);
//             return;
//         }
//         if (!formValue.thumbnailImage) {
//             Swal.fire("Please upload a Breed Photo!");
//             setLoading(false);
//             return;
//         }

//         if (multipleFileStatus) {
//             Swal.fire("Images abhi upload ho rahi hain, thoda ruk jao!");
//             setLoading(false);
//             return;
//         }

//         const topTraits = traitsInput
//             .split(',')
//             .map((t) => t.trim())
//             .filter(Boolean);

//         const dataValue = {
//             ...formValue,
//             description: descriptionValue,
//             careInstructions: careValue,
//             ageGroup: ageGroupSelectedOptions,
//             topTraits,
//         };

//         try {
//             const res = await axios.post(`${Url}/api/pet-breed`, dataValue, {
//                 headers: {
//                     'Content-Type': 'application/json'
//                 }
//             });

//             console.log("RESPONSE:", res.data);

//             Swal.fire({
//                 position: "top-end",
//                 icon: "success",
//                 title: "Breed Added Successfully",
//                 showConfirmButton: false,
//                 timer: 1500
//             });

//             navigate("/dashboard/pet-breeds");

//         } catch (error) {
//             console.error("ADD BREED ERROR:", error);
//             Swal.fire({
//                 position: "top-end",
//                 icon: "error",
//                 title: error?.response?.data?.message || "Something Went Wrong",
//                 showConfirmButton: false,
//                 timer: 1500
//             });
//         } finally {
//             setLoading(false);
//         }
//     };

//     const isSubmitDisabled = loading || uploadLoading || multipleFileStatus;

//     return (
//         <>
//             <Helmet>
//                 <title> Dashboard: Add Pet Breed </title>
//             </Helmet>

//             <Container>
//                 <div className="mb-4 text-primary">
//                     <h2 className="text-capitalize">Add Pet Breed Guide</h2>
//                     <p className="text-secondary mb-0" style={{ fontSize: 14 }}>
//                         This is an informational listing (breed guide) — no price, SKU, or sale fields. Enquiries are captured separately, not purchases.
//                     </p>
//                 </div>
//                 <div className="p-3 bg-light rounded shadow border">
//                     <form action="" onSubmit={e => submit(e)}>
//                         <div className="row">

//                             {/* Breed Name */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Breed Name</p>
//                                     <input
//                                         type="text"
//                                         name="name"
//                                         value={formValue.name || ""}
//                                         onChange={e => formHandle(e)}
//                                         className="form-control"
//                                         placeholder="e.g. Rottweiler"
//                                         required
//                                     />
//                                 </div>
//                             </div>

//                             {/* Image Alt Tag */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Image Alt Tag</p>
//                                     <input
//                                         type="text"
//                                         name="altTag"
//                                         value={formValue.altTag || ""}
//                                         onChange={e => formHandle(e)}
//                                         className="form-control"
//                                     />
//                                 </div>
//                             </div>

//                             {/* Type / Size / Energy Level — drives the filter chips */}
//                             <div className="col-lg-4 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Pet Type</p>
//                                     <select
//                                         name="type"
//                                         value={formValue.type || ""}
//                                         onChange={e => formHandle(e)}
//                                         className="form-select"
//                                         required
//                                     >
//                                         <option value='' disabled>Choose Type</option>
//                                         <option value="Dog">Dog</option>
//                                         <option value="Cat">Cat</option>
//                                     </select>
//                                 </div>
//                             </div>

//                             <div className="col-lg-4 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Size</p>
//                                     <select
//                                         name="size"
//                                         value={formValue.size || ""}
//                                         onChange={e => formHandle(e)}
//                                         className="form-select"
//                                         required
//                                     >
//                                         <option value='' disabled>Choose Size</option>
//                                         {sizeOptions.map((s) => (
//                                             <option key={s} value={s}>{s}</option>
//                                         ))}
//                                     </select>
//                                 </div>
//                             </div>

//                             <div className="col-lg-4 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Energy Level</p>
//                                     <select
//                                         name="energyLevel"
//                                         value={formValue.energyLevel || ""}
//                                         onChange={e => formHandle(e)}
//                                         className="form-select"
//                                         required
//                                     >
//                                         <option value='' disabled>Choose Energy Level</option>
//                                         {energyOptions.map((en) => (
//                                             <option key={en} value={en}>{en}</option>
//                                         ))}
//                                     </select>
//                                 </div>
//                             </div>

//                             {/* Breed Photo (thumbnail) */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Breed Photo</p>
//                                     <input
//                                         type="file"
//                                         name="thumbnailImage"
//                                         onChange={e => thumbnailHandle(e)}
//                                         accept="image/*"
//                                         className="form-control"
//                                         required
//                                     />
//                                     <div className="d-flex justify-content-end gap-2 pt-2">
//                                         {uploadLoading && progressValue > 0 && (
//                                             <progress
//                                                 className="flex-grow-1"
//                                                 value={progressValue}
//                                                 max="100"
//                                                 style={{ height: "5px" }}
//                                             />
//                                         )}
//                                         {uploadLoading && (
//                                             <small className="fs-10 text-secondary">
//                                                 Uploading... {progressValue}%
//                                             </small>
//                                         )}
//                                         {!uploadLoading && uploadStatus && formValue.thumbnailImage && (
//                                             <small className="fs-10 text-success">
//                                                 ✓ success
//                                             </small>
//                                         )}
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Gallery Images (optional) */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">
//                                         Gallery Images <span className="fw-normal text-secondary">(optional)</span>
//                                     </p>
//                                     <input
//                                         type="file"
//                                         name="images"
//                                         multiple
//                                         onChange={e => fileHandle(e)}
//                                         className="form-control"
//                                         accept="image/*"
//                                     />
//                                     {multipleFileStatus && (
//                                         <progress
//                                             className="w-100"
//                                             value={multipleFileProgress}
//                                             max="100"
//                                             style={{ height: "5px" }}
//                                         />
//                                     )}
//                                     {totalfiles !== 0 && (
//                                         <div className="d-flex justify-content-end gap-2 pt-2 align-items-center">
//                                             <progress
//                                                 className="flex-grow-1"
//                                                 value={(totalUpload / totalfiles) * 100}
//                                                 max="100"
//                                                 style={{ height: "5px" }}
//                                             />
//                                             <small className="fs-10 text-secondary w-max-content">
//                                                 {totalUpload}/{totalfiles}
//                                             </small>
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>

//                             {/* ===== Breed Stat Card fields ===== */}
//                             <div className="col-12">
//                                 <hr />
//                                 <p className="fw-bold text-primary mb-2">Breed Stat Card</p>
//                             </div>

//                             <div className="col-lg-4 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Height</p>
//                                     <input
//                                         type="text"
//                                         name="height"
//                                         value={formValue.height || ""}
//                                         onChange={e => formHandle(e)}
//                                         className="form-control"
//                                         placeholder="e.g. 22-27 inches"
//                                         required
//                                     />
//                                 </div>
//                             </div>

//                             <div className="col-lg-4 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Weight</p>
//                                     <input
//                                         type="text"
//                                         name="weight"
//                                         value={formValue.weight || ""}
//                                         onChange={e => formHandle(e)}
//                                         className="form-control"
//                                         placeholder="e.g. 35-60 kg"
//                                         required
//                                     />
//                                 </div>
//                             </div>

//                             <div className="col-lg-4 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Life Expectancy</p>
//                                     <input
//                                         type="text"
//                                         name="lifeExpectancy"
//                                         value={formValue.lifeExpectancy || ""}
//                                         onChange={e => formHandle(e)}
//                                         className="form-control"
//                                         placeholder="e.g. 8-10 years"
//                                         required
//                                     />
//                                 </div>
//                             </div>

//                             <div className="col-lg-4 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Origin</p>
//                                     <input
//                                         type="text"
//                                         name="origin"
//                                         value={formValue.origin || ""}
//                                         onChange={e => formHandle(e)}
//                                         className="form-control"
//                                         placeholder="e.g. Germany"
//                                         required
//                                     />
//                                 </div>
//                             </div>

//                             <div className="col-lg-4 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Shedding</p>
//                                     <input
//                                         type="text"
//                                         name="shedding"
//                                         value={formValue.shedding || ""}
//                                         onChange={e => formHandle(e)}
//                                         className="form-control"
//                                         placeholder="e.g. Moderate"
//                                         required
//                                     />
//                                 </div>
//                             </div>

//                             <div className="col-lg-4 col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Top 5 Traits</p>
//                                     <input
//                                         type="text"
//                                         value={traitsInput}
//                                         onChange={(e) => setTraitsInput(e.target.value)}
//                                         className="form-control"
//                                         placeholder="Confident, Protective, Strong, Loyal, Calm"
//                                     />
//                                     <small className="text-secondary">Comma separated</small>
//                                 </div>
//                             </div>

//                             {/* Age Group */}
//                             <div className="col-lg-6 col-12 mb-2">
//                                 <p className="mb-0 fw-bold">Suitable Age Group</p>
//                                 {ageGroupError && (
//                                     <p ref={errorRef} className="text-danger fw-normal mb-1">
//                                         Please select at least one option!
//                                     </p>
//                                 )}
//                                 {ageGroupOptions.map((option, index) => (
//                                     <div key={index} className="form-check">
//                                         <input
//                                             type="checkbox"
//                                             id={option}
//                                             checked={ageGroupSelectedOptions.includes(option)}
//                                             onChange={() => handleAgeGroupChange(option)}
//                                             className="form-check-input"
//                                         />
//                                         <label htmlFor={option} className="form-check-label">
//                                             {option}
//                                         </label>
//                                     </div>
//                                 ))}
//                             </div>

//                             {/* Short Description */}
//                             <div className="col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">
//                                         Short Description <span className="fw-normal text-secondary">(optional, used in listing cards)</span>
//                                     </p>
//                                     <textarea
//                                         className="form-control"
//                                         name="shortDescription"
//                                         value={formValue.shortDescription || ""}
//                                         onChange={e => formHandle(e)}
//                                         rows="2"
//                                     />
//                                 </div>
//                             </div>

//                             {/* Description */}
//                             <div className="col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">Description</p>
//                                     <div className="text-editor bg-white rounded">
//                                         <ReactQuill
//                                             theme="snow"
//                                             value={descriptionValue}
//                                             onChange={setDescriptionValue}
//                                             placeholder={"Tell people about this breed..."}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Care Instructions */}
//                             <div className="col-12 mb-2">
//                                 <div className="form-group">
//                                     <p className="mb-0 fw-bold">
//                                         Care Instructions <span className="fw-normal text-secondary">(optional)</span>
//                                     </p>
//                                     <div className="text-editor bg-white">
//                                         <ReactQuill
//                                             theme="snow"
//                                             value={careValue}
//                                             onChange={setCareValue}
//                                             placeholder={"Grooming, diet, exercise tips..."}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Submit */}
//                             <div className="col-12">
//                                 <div className="form-group text-end">
//                                     <button
//                                         className="btn btn-primary"
//                                         type="submit"
//                                         disabled={isSubmitDisabled}
//                                     >
//                                         {loading
//                                             ? "Saving..."
//                                             : (uploadLoading || multipleFileStatus)
//                                                 ? "Uploading..."
//                                                 : "Post"}
//                                     </button>
//                                 </div>
//                             </div>

//                         </div>
//                     </form>
//                 </div>
//             </Container>
//         </>
//     )
// }

// export default AddPetBreed








import React, { useRef, useState } from "react"
import { Helmet } from 'react-helmet-async';
import { Container } from "@mui/material";
import ReactQuill from 'react-quill';
import axios from "axios";
import Swal from 'sweetalert2';
import { useNavigate } from "react-router-dom";

import { Url, awsFileUrl } from "../url/url";
import 'react-quill/dist/quill.snow.css';
import "../App.css"

const ageGroupOptions = ['0-12 months', '1-2 years', '3+ years', '5+ years', '10+ years'];
const sizeOptions = ['Small', 'Medium', 'Large', 'Giant'];
const energyOptions = ['Low Energy', 'Medium Energy', 'High Energy'];

const AddPetBreed = () => {
    const navigate = useNavigate()

    const [descriptionValue, setDescriptionValue] = useState('');
    const [careValue, setCareValue] = useState('');
    const [loading, setLoading] = useState(false)
    const [formValue, setFormValue] = useState({});

    const [ageGroupSelectedOptions, setAgeGroupSelectedOptions] = useState([]);
    const [ageGroupError, setAgeGroupError] = useState(false);
    const errorRef = useRef(null);

    // Top 5 Traits — kept as a comma separated input, split into an array on submit
    const [traitsInput, setTraitsInput] = useState('');

    const [uploadLoading, setUploadLoading] = useState(false);
    const [progressValue, setProgressValue] = useState(0);
    const [uploadStatus, setUploadStatus] = useState(false);

    const [multipleFileProgress, setMultipleFileProgress] = useState(0)
    const [totalfiles, setTotalFiles] = useState(0)
    const [totalUpload, setTotalUpload] = useState(0)
    const [multipleFileStatus, setMultipleFileStatus] = useState(false)

    const handleAgeGroupChange = (option) => {
        setAgeGroupSelectedOptions((prev) =>
            prev.includes(option)
                ? prev.filter((item) => item !== option)
                : [...prev, option]
        );
    };

    const formHandle = (e) => {
        const name = e.target.name
        const value = e.target.value
        setFormValue({ ...formValue, [name]: value })
    }

    // ---------------------------------------------
    // Popular Breed checkbox — optional flag, uses `checked` not `value`
    // ---------------------------------------------
    const popularHandle = (e) => {
        setFormValue({ ...formValue, isPopular: e.target.checked })
    }

    // ---------------------------------------------
    // Thumbnail upload — same presigned-URL → S3 PUT pattern as products
    // ---------------------------------------------
    const thumbnailHandle = async (e) => {
        const file = e.target.files[0]
        const name = e.target.name
        setUploadLoading(true)
        setUploadStatus(false)

        try {
            if (file) {
                const response = await axios.post(`${Url}/api/createPresignedUrl/products`, {
                    fileName: file.name,
                    fileType: file.type
                })

                if (response.status === 200) {
                    const { preSignedUrl, key } = response?.data
                    const responseFileSave = await axios.put(preSignedUrl, file, {
                        onUploadProgress: (progressEvent) => {
                            const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                            setProgressValue(progress)
                        },
                    })

                    if (responseFileSave.status === 200) {
                        const fileUrl = `${awsFileUrl}/${key}`
                        setFormValue({ ...formValue, [name]: fileUrl })
                        setUploadStatus(true)
                        setUploadLoading(false)
                        setProgressValue(0)
                    } else {
                        setUploadLoading(false)
                        setProgressValue(0)
                        setUploadStatus(false)
                        Swal.fire("Thumbnail upload failed, please try again!");
                    }
                } else {
                    setUploadLoading(false)
                }
            } else {
                setUploadLoading(false)
            }
        } catch (error) {
            console.log(error);
            setUploadLoading(false)
            setUploadStatus(false)
            Swal.fire("Thumbnail upload failed, please try again!");
        }
    }

    // ---------------------------------------------
    // Gallery images upload (optional) — same sequential presigned-URL pattern
    // ---------------------------------------------
    const fileHandle = async (e) => {
        const files = e.target.files;
        const name = e.target.name;
        const uploadedFiles = [];
        setTotalFiles(files?.length);
        setTotalUpload(0);
        setMultipleFileProgress(0);
        setMultipleFileStatus(true);

        try {
            await Array.from(files).reduce(async (previousPromise, file, i) => {
                await previousPromise;
                if (file) {
                    const response = await axios.post(`${Url}/api/createPresignedUrl/products`, {
                        fileName: file.name,
                        fileType: file.type
                    });

                    if (response.status === 200) {
                        const { preSignedUrl, key } = response?.data;
                        const responseFileSave = await axios.put(preSignedUrl, file, {
                            onUploadProgress: (progressEvent) => {
                                const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                                setMultipleFileProgress(progress);
                            },
                        });

                        if (responseFileSave.status === 200) {
                            const fileUrl = `${awsFileUrl}/${key}`;
                            setTotalUpload(i + 1);
                            uploadedFiles.push(fileUrl);
                        } else {
                            throw new Error('File upload failed');
                        }
                    }
                }
            }, Promise.resolve());

            setFormValue({ ...formValue, [name]: uploadedFiles });
            setMultipleFileStatus(false);
        } catch (error) {
            console.log(error);
            Swal.fire("Images upload failed, please try again!");
        } finally {
            setMultipleFileStatus(false);
        }
    };

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setAgeGroupError(false);

        // Validate type / size / energy level
        if (!formValue.type) {
            Swal.fire("Please select Pet Type (Dog/Cat)!");
            setLoading(false);
            return;
        }
        if (!formValue.size) {
            Swal.fire("Please select Size!");
            setLoading(false);
            return;
        }
        if (!formValue.energyLevel) {
            Swal.fire("Please select Energy Level!");
            setLoading(false);
            return;
        }

        // Validate stat fields
        if (!formValue.height || !formValue.weight || !formValue.lifeExpectancy || !formValue.origin || !formValue.shedding) {
            Swal.fire("Please fill all breed stat fields (Height, Weight, Life Expectancy, Origin, Shedding)!");
            setLoading(false);
            return;
        }

        // Validate description
        if (!descriptionValue) {
            Swal.fire("Description is required!");
            setLoading(false);
            return;
        }

        // Thumbnail
        if (uploadLoading) {
            Swal.fire("Thumbnail image abhi upload ho raha hai, thoda ruk jao!");
            setLoading(false);
            return;
        }
        if (!formValue.thumbnailImage) {
            Swal.fire("Please upload a Breed Photo!");
            setLoading(false);
            return;
        }

        if (multipleFileStatus) {
            Swal.fire("Images abhi upload ho rahi hain, thoda ruk jao!");
            setLoading(false);
            return;
        }

        const topTraits = traitsInput
            .split(',')
            .map((t) => t.trim())
            .filter(Boolean);

        const dataValue = {
            ...formValue,
            description: descriptionValue,
            careInstructions: careValue,
            ageGroup: ageGroupSelectedOptions,
            topTraits,
            isPopular: !!formValue.isPopular,
        };

        try {
            const res = await axios.post(`${Url}/api/pet-breed`, dataValue, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            console.log("RESPONSE:", res.data);

            Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Breed Added Successfully",
                showConfirmButton: false,
                timer: 1500
            });

            navigate("/dashboard/pet-breeds");

        } catch (error) {
            console.error("ADD BREED ERROR:", error);
            Swal.fire({
                position: "top-end",
                icon: "error",
                title: error?.response?.data?.message || "Something Went Wrong",
                showConfirmButton: false,
                timer: 1500
            });
        } finally {
            setLoading(false);
        }
    };

    const isSubmitDisabled = loading || uploadLoading || multipleFileStatus;

    return (
        <>
            <Helmet>
                <title> Dashboard: Add Pet Breed </title>
            </Helmet>

            <Container>
                <div className="mb-4 text-primary">
                    <h2 className="text-capitalize">Add Pet Breed Guide</h2>
                    <p className="text-secondary mb-0" style={{ fontSize: 14 }}>
                        This is an informational listing (breed guide) — no price, SKU, or sale fields. Enquiries are captured separately, not purchases.
                    </p>
                </div>
                <div className="p-3 bg-light rounded shadow border">
                    <form action="" onSubmit={e => submit(e)}>
                        <div className="row">

                            {/* Breed Name */}
                            <div className="col-lg-6 col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">Breed Name</p>
                                    <input
                                        type="text"
                                        name="name"
                                        value={formValue.name || ""}
                                        onChange={e => formHandle(e)}
                                        className="form-control"
                                        placeholder="e.g. Rottweiler"
                                        required
                                    />
                                </div>
                            </div>

                            {/* Image Alt Tag */}
                            <div className="col-lg-6 col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">Image Alt Tag</p>
                                    <input
                                        type="text"
                                        name="altTag"
                                        value={formValue.altTag || ""}
                                        onChange={e => formHandle(e)}
                                        className="form-control"
                                    />
                                </div>
                            </div>

                            {/* Type / Size / Energy Level — drives the filter chips */}
                            <div className="col-lg-4 col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">Pet Type</p>
                                    <select
                                        name="type"
                                        value={formValue.type || ""}
                                        onChange={e => formHandle(e)}
                                        className="form-select"
                                        required
                                    >
                                        <option value='' disabled>Choose Type</option>
                                        <option value="Dog">Dog</option>
                                        <option value="Cat">Cat</option>
                                    </select>
                                </div>
                            </div>

                            <div className="col-lg-4 col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">Size</p>
                                    <select
                                        name="size"
                                        value={formValue.size || ""}
                                        onChange={e => formHandle(e)}
                                        className="form-select"
                                        required
                                    >
                                        <option value='' disabled>Choose Size</option>
                                        {sizeOptions.map((s) => (
                                            <option key={s} value={s}>{s}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div className="col-lg-4 col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">Energy Level</p>
                                    <select
                                        name="energyLevel"
                                        value={formValue.energyLevel || ""}
                                        onChange={e => formHandle(e)}
                                        className="form-select"
                                        required
                                    >
                                        <option value='' disabled>Choose Energy Level</option>
                                        {energyOptions.map((en) => (
                                            <option key={en} value={en}>{en}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                         {/* Popular Breed — optional flag, NOT required */}
<div className="col-lg-6 col-12 mb-2 d-flex align-items-end">
    <div className="form-check">
        <label
            htmlFor="popularBreedCheckbox"
            className="form-check-label fw-bold d-flex align-items-center gap-2"
        >
            <input
                type="checkbox"
                id="popularBreedCheckbox"
                name="isPopular"
                checked={formValue.isPopular || false}
                onChange={e => popularHandle(e)}
                className="form-check-input"
            />
            Mark as Popular Breed
        </label>
    </div>
</div>

                            {/* Breed Photo (thumbnail) */}
                            <div className="col-lg-6 col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">Breed Photo</p>
                                    <input
                                        type="file"
                                        name="thumbnailImage"
                                        onChange={e => thumbnailHandle(e)}
                                        accept="image/*"
                                        className="form-control"
                                        required
                                    />
                                    <div className="d-flex justify-content-end gap-2 pt-2">
                                        {uploadLoading && progressValue > 0 && (
                                            <progress
                                                className="flex-grow-1"
                                                value={progressValue}
                                                max="100"
                                                style={{ height: "5px" }}
                                            />
                                        )}
                                        {uploadLoading && (
                                            <small className="fs-10 text-secondary">
                                                Uploading... {progressValue}%
                                            </small>
                                        )}
                                        {!uploadLoading && uploadStatus && formValue.thumbnailImage && (
                                            <small className="fs-10 text-success">
                                                ✓ success
                                            </small>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Gallery Images (optional) */}
                            <div className="col-lg-6 col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">
                                        Gallery Images <span className="fw-normal text-secondary">(optional)</span>
                                    </p>
                                    <input
                                        type="file"
                                        name="images"
                                        multiple
                                        onChange={e => fileHandle(e)}
                                        className="form-control"
                                        accept="image/*"
                                    />
                                    {multipleFileStatus && (
                                        <progress
                                            className="w-100"
                                            value={multipleFileProgress}
                                            max="100"
                                            style={{ height: "5px" }}
                                        />
                                    )}
                                    {totalfiles !== 0 && (
                                        <div className="d-flex justify-content-end gap-2 pt-2 align-items-center">
                                            <progress
                                                className="flex-grow-1"
                                                value={(totalUpload / totalfiles) * 100}
                                                max="100"
                                                style={{ height: "5px" }}
                                            />
                                            <small className="fs-10 text-secondary w-max-content">
                                                {totalUpload}/{totalfiles}
                                            </small>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* ===== Breed Stat Card fields ===== */}
                            <div className="col-12">
                                <hr />
                                <p className="fw-bold text-primary mb-2">Breed Stat Card</p>
                            </div>

                            <div className="col-lg-4 col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">Height</p>
                                    <input
                                        type="text"
                                        name="height"
                                        value={formValue.height || ""}
                                        onChange={e => formHandle(e)}
                                        className="form-control"
                                        placeholder="e.g. 22-27 inches"
                                        required
                                    />
                                </div>
                            </div>

                            <div className="col-lg-4 col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">Weight</p>
                                    <input
                                        type="text"
                                        name="weight"
                                        value={formValue.weight || ""}
                                        onChange={e => formHandle(e)}
                                        className="form-control"
                                        placeholder="e.g. 35-60 kg"
                                        required
                                    />
                                </div>
                            </div>

                            <div className="col-lg-4 col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">Life Expectancy</p>
                                    <input
                                        type="text"
                                        name="lifeExpectancy"
                                        value={formValue.lifeExpectancy || ""}
                                        onChange={e => formHandle(e)}
                                        className="form-control"
                                        placeholder="e.g. 8-10 years"
                                        required
                                    />
                                </div>
                            </div>

                            <div className="col-lg-4 col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">Origin</p>
                                    <input
                                        type="text"
                                        name="origin"
                                        value={formValue.origin || ""}
                                        onChange={e => formHandle(e)}
                                        className="form-control"
                                        placeholder="e.g. Germany"
                                        required
                                    />
                                </div>
                            </div>

                            <div className="col-lg-4 col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">Shedding</p>
                                    <input
                                        type="text"
                                        name="shedding"
                                        value={formValue.shedding || ""}
                                        onChange={e => formHandle(e)}
                                        className="form-control"
                                        placeholder="e.g. Moderate"
                                        required
                                    />
                                </div>
                            </div>

                            <div className="col-lg-4 col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">Top 5 Traits</p>
                                    <input
                                        type="text"
                                        value={traitsInput}
                                        onChange={(e) => setTraitsInput(e.target.value)}
                                        className="form-control"
                                        placeholder="Confident, Protective, Strong, Loyal, Calm"
                                    />
                                    <small className="text-secondary">Comma separated</small>
                                </div>
                            </div>

                            {/* Age Group */}
                            <div className="col-lg-6 col-12 mb-2">
                                <p className="mb-0 fw-bold">Suitable Age Group</p>
                                {ageGroupError && (
                                    <p ref={errorRef} className="text-danger fw-normal mb-1">
                                        Please select at least one option!
                                    </p>
                                )}
                                {ageGroupOptions.map((option, index) => (
                                    <div key={index} className="form-check">
                                        <input
                                            type="checkbox"
                                            id={`ageGroup-${index}`}
                                            checked={ageGroupSelectedOptions.includes(option)}
                                            onChange={() => handleAgeGroupChange(option)}
                                            className="form-check-input"
                                        />
                                        <label htmlFor={`ageGroup-${index}`} className="form-check-label">
                                            {option}
                                        </label>
                                    </div>
                                ))}
                            </div>

                            {/* Short Description */}
                            <div className="col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">
                                        Short Description <span className="fw-normal text-secondary">(optional, used in listing cards)</span>
                                    </p>
                                    <textarea
                                        className="form-control"
                                        name="shortDescription"
                                        value={formValue.shortDescription || ""}
                                        onChange={e => formHandle(e)}
                                        rows="2"
                                    />
                                </div>
                            </div>

                            {/* Description */}
                            <div className="col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">Description</p>
                                    <div className="text-editor bg-white rounded">
                                        <ReactQuill
                                            theme="snow"
                                            value={descriptionValue}
                                            onChange={setDescriptionValue}
                                            placeholder={"Tell people about this breed..."}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Care Instructions */}
                            <div className="col-12 mb-2">
                                <div className="form-group">
                                    <p className="mb-0 fw-bold">
                                        Care Instructions <span className="fw-normal text-secondary">(optional)</span>
                                    </p>
                                    <div className="text-editor bg-white">
                                        <ReactQuill
                                            theme="snow"
                                            value={careValue}
                                            onChange={setCareValue}
                                            placeholder={"Grooming, diet, exercise tips..."}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Submit */}
                            <div className="col-12">
                                <div className="form-group text-end">
                                    <button
                                        className="btn btn-primary"
                                        type="submit"
                                        disabled={isSubmitDisabled}
                                    >
                                        {loading
                                            ? "Saving..."
                                            : (uploadLoading || multipleFileStatus)
                                                ? "Uploading..."
                                                : "Post"}
                                    </button>
                                </div>
                            </div>

                        </div>
                    </form>
                </div>
            </Container>
        </>
    )
}

export default AddPetBreed